import { useTranslator } from '@bluebeam/react-i18n';
import OverlaySection from 'components/Overlays/OverlaySection';
import React from 'react';
import { Project } from 'records/Project';

type Props = {
  project: Project;
};
const ViewProjectDetailsSection: React.FC<Props> = ({ project }) => {
  const { translate } = useTranslator(['mapView']);
  const { street, city, state, zipcode, name } = project;

  const partialAddress = [street, city, state]
    .filter((i) => i.length > 0)
    .join(', ');
  const address = `${partialAddress} ${zipcode}`.trim();

  return (
    <OverlaySection
      label={translate('mapView:viewProjectDetailsSection.projectDetails')}
    >
      <div className="truncate">{name}</div>
      <div className="truncate">{address}</div>
    </OverlaySection>
  );
};

export default ViewProjectDetailsSection;
